import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import workspaceAPI from '../../services/workspaceAPI';

const WorkspaceProperties = () => {
  const [properties, setProperties] = useState([]);
  const [canManage, setCanManage] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    workspaceAPI
      .getProperties()
      .then((res) => {
        setProperties(res.data.properties || []);
        setCanManage(res.data.canManage);
      })
      .catch((err) => setError(err.response?.data?.message || 'Failed to load properties'));
  }, []);

  if (error) return <p className="workspace-alert error">{error}</p>;

  return (
    <div>
      <h1 className="workspace-page-title">Property listing management</h1>
      <p className="workspace-page-subtitle">All company stay listings in one place.</p>
      {canManage && (
        <Link to="/host/add-property" className="workspace-btn" style={{ display: 'inline-block', marginBottom: 16, textDecoration: 'none' }}>
          + Add property
        </Link>
      )}
      <div className="workspace-table-wrap">
        <table className="workspace-table">
          <thead>
            <tr><th>Name</th><th>Location</th><th>Status</th><th>Price</th></tr>
          </thead>
          <tbody>
            {properties.map((p) => (
              <tr key={p._id}>
                <td><Link to={`/host/property/${p._id}`}>{p.name}</Link></td>
                <td>{[p.city, p.state].filter(Boolean).join(', ') || '—'}</td>
                <td>{p.status || 'active'}</td>
                <td>{p.basePrice ? `₹${p.basePrice}` : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {properties.length === 0 && <p style={{ padding: 16 }}>No properties yet.</p>}
      </div>
    </div>
  );
};

export default WorkspaceProperties;
